<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Laboratório" nzSubtitle=" - Lançamento de laboratórios.">
    </nz-page-header>

    <form nz-form [formGroup]="laboratorioForm" autocomplete="off" (ngSubmit)="onSubmitLaboratorio()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Descrição:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="descricao" maxlength="45" formControlName="descricao" placeholder="Descrição" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idlaboratorio" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idlaboratorio" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>